import { render, staticRenderFns } from "./TableProducts.vue?vue&type=template&id=875e7820&scoped=true&"
import script from "./TableProducts.vue?vue&type=script&lang=js&"
export * from "./TableProducts.vue?vue&type=script&lang=js&"
import style0 from "./TableProducts.vue?vue&type=style&index=0&id=875e7820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875e7820",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText})
